import React, { useState } from "react";
import "./MerchantDashboard.css";
import { useSelector } from "react-redux";
import DateFilter from "../../../components/common/DateFilter";

function DashboardHeader({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  merChantData,
}) {
  let token = useSelector((store) => store.userReducer.token);

  const handleDateChange = (start, end) => {
    setStartDate(start);
    setEndDate(end);

    merChantData(token, start, end);
  };

  return (
    <>
      <DateFilter onDateChange={handleDateChange} />
    </>
  );
}

export default DashboardHeader;
